<template>
  <v-layout :column="$vuetify.breakpoint.xsOnly">
    <v-flex class="pr-30" shrink>
      <sponsor-logo-field
        v-model="form.logo"
        :upload-options="{ path: `${eventId}/sponsors` }"
      />
    </v-flex>
    <v-flex>
      <text-field
        v-model.trim="form.name"
        autofocus
        :validator="vs.form.name"
        :label="adminText('workflowsAll.name_709a232', 'Name')"
      />
      <text-field
        v-model.trim="form.sponsorLink"
        :validator="vs.form.sponsorLink"
        :label="adminText('workflowsAll.website_2e8a57c', 'Website')"
        placeholder="www.example.com"
      />
    </v-flex>
  </v-layout>
</template>

<script>
import WorkflowDisplay from '@/admin-i18n/workflows-all-display'
import SponsorLogoField from './sponsor-logo-field.vue'

export default {
  mixins: [WorkflowDisplay],
  name: 'sponsor-form',
  components: {
    SponsorLogoField,
  },
  props: {
    initialValues: {
      type: Object,
      default: null,
    },
    vs: {
      type: Object,
      default: () => ({}),
    },
    eventId: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      form: this.initialValues || {},
    }
  },
  watch: {
    initialValues: {
      handler(val) {
        this.form = val || {}
      },
    },
    form: {
      handler(val) {
        this.$emit('values', val)
      },
      deep: true,
    },
  },
}
</script>

<style scoped>
.pr-30 {
  padding-right: 30px;
}
</style>
